<template>
  <div class="list-controls" :aria-busy="loading ? 'true' : 'false'">
    <p v-if="error" role="alert">{{ error }} <button type="button" @click="$emit('retry')">Try again</button></p>
    <p v-else role="status">{{ loading ? 'Loading…' : total ? `${start}–${end} of ${total.toLocaleString()}` : '0 results' }}</p>
    <div class="list-paging">
      <label>Rows per page <select :value="size" :disabled="loading" @change="$emit('size', Number($event.target.value))"><option :value="25">25</option><option :value="50">50</option><option :value="100">100</option></select></label>
      <button type="button" :disabled="loading || page <= 1" @click="$emit('page', page - 1)">Previous</button>
      <span>Page {{ page }} of {{ Math.max(1, Math.ceil(total / size)) }}</span>
      <button type="button" :disabled="loading || page * size >= total" @click="$emit('page', page + 1)">Next</button>
    </div>
  </div>
</template>
<script>
export default { props: { total: Number, page: Number, size: Number, loading: Boolean, error: String },
  computed: { start() { return (this.page - 1) * this.size + 1; }, end() { return Math.min(this.page * this.size, this.total); } } };
</script>
<style scoped>
.list-controls, .list-paging { display: flex; flex-wrap: wrap; align-items: center; gap: 12px; }
.list-controls { justify-content: space-between; padding: 8px 0; margin-bottom: 8px; font-size: 14px; color: #555; }
.list-paging label { display: flex; align-items: center; gap: 8px; }
.list-controls p { margin: 0; }
button, select { min-height: 36px; padding: 6px 10px; background: white; border: 1px solid #d4dadd; border-radius: 4px; color: #333; font: inherit; }
button:hover:not(:disabled) { background: #f2f5fa; border-color: #859bb5; }
button { cursor: pointer; } button:disabled { opacity: .5; cursor: not-allowed; }
button:focus-visible, select:focus-visible { outline: 2px solid #163c4c; outline-offset: 2px; }
</style>
